// extracted by mini-css-extract-plugin
export default {"suspenseLoader":"router_suspenseLoader__k20QS"};